module.exports = __webpack_public_path__ + "static/pcb1-b535917518c4a2f7bc59ffc2a83ea759.png";